import { useEffect, useRef, useState } from "react";
import DashboardIcon from "./icons/dashboard";
import SideBarItem from "./side_bar_item";
import { ChatBubbleOvalLeftEllipsisIcon } from "@heroicons/react/24/outline";
import {
	AiOutlineMenuFold,
	AiOutlineMenuUnfold,
	AiOutlineSend,
} from "react-icons/ai";
import { RiMailSendLine } from "react-icons/ri";
import Logo from "../assets/logo.png";
import {
	FaPray,
	FaMosque,
	FaUsers,
	FaQuran,
	FaWpforms,
	FaRegImages,
	FaCogs,
} from "react-icons/fa";
import { NavLink, useLocation } from "react-router-dom";
const Sidebar = ({ sidebarOpen, setSidebarOpen }) => {
	const location = useLocation();
	const { pathname } = location;

	const trigger = useRef(null);
	const sidebar = useRef(null);

	// close on click outside
	useEffect(() => {
		const clickHandler = ({ target }) => {
			if (!sidebar.current || !trigger.current) return;
			if (
				!sidebarOpen ||
				sidebar.current.contains(target) ||
				trigger.current.contains(target)
			)
				return;
			setSidebarOpen(false);
		};
		document.addEventListener("click", clickHandler);
		return () => document.removeEventListener("click", clickHandler);
	});

	// close if the esc key is pressed
	useEffect(() => {
		const keyHandler = ({ keyCode }) => {
			if (!sidebarOpen || keyCode !== 27) return;
			setSidebarOpen(false);
		};
		document.addEventListener("keydown", keyHandler);
		return () => document.removeEventListener("keydown", keyHandler);
	});
	console.log("SIDE SIDE BAR OPEN", sidebarOpen);
	return (
		<aside
			ref={sidebar}
			className={`absolute left-0 top-0 z-[9999] flex h-screen w-72 flex-col overflow-y-hidden duration-300 ease-linear dark:bg-white lg:static lg:translate-x-0  shadow-xl bg-whiten ${
				sidebarOpen ? "translate-x-0" : "-translate-x-full"
			}`}>
			<div className="relative">
				<NavLink to="/">
					<div className="flex justify-center items-center mx-auto">
						<img
							src={Logo}
							alt="Logo"
							className="h-16 w-16  md:h-16 md:w-16 p-2"
						/>
						<h3 className="font-bold font-serif text-4xl"> Shifa</h3>
					</div>
				</NavLink>

				<button
					ref={trigger}
					onClick={() => setSidebarOpen(!sidebarOpen)}
					aria-controls="sidebar"
					aria-expanded={sidebarOpen}
					className="block lg:hidden absolute top-0 right-0 bg-gray">
					<AiOutlineMenuFold />
				</button>
			</div>
			<div className="no-scrollbar flex flex-col overflow-y-auto duration-300 ease-linear">
				<nav className=" py-4 px-4 lg:px-6">
					<ul>
						<SideBarItem
							href={"/"}
							icon={<DashboardIcon />}
							name={"Dashboard"}
						/>
						{/* <SideBarItem
							href={"/chat"}
							icon={
								<ChatBubbleOvalLeftEllipsisIcon
									className="h-6 w-6 text-slate-700"
									aria-hidden="true"
								/>
							}
							name={"Chat"}
						/>{" "} */}
						<SideBarItem
							href={"/users"}
							icon={<FaUsers />}
							name={"Users"}
							isActive={pathname === "/users"}
						/>{" "}
						<SideBarItem href={"/duas"} icon={<FaPray />} name={"Duas"} />
						<SideBarItem
							href={"/requests"}
							icon={<RiMailSendLine />}
							name={"Requests"}
						/>
						<SideBarItem
							href={"/invites"}
							icon={<AiOutlineSend />}
							name={"Invites"}
						/>
						{/* <SideBarItem
							href={"/tawassol"}
							icon={<FaMosque />}
							name={"Tawassol"}
						/> */}
						<SideBarItem
							href={"/Khatam al Quaran"}
							icon={<FaQuran />}
							name={"Khatam al quran"}
						/>
						<SideBarItem
							href={"/well-cards"}
							icon={<FaRegImages />}
							name={"Well Cards"}
						/>
						{/* <SideBarItem href={"/forms"} icon={<FaWpforms />} name={"Forms"} /> */}
						<SideBarItem
							href={"/settings"}
							icon={<FaCogs />}
							name={"Settings"}
						/>
						{/* Add more sidebar links as needed */}
					</ul>
				</nav>
			</div>
		</aside>
	);
};

export default Sidebar;
